import { render, staticRenderFns } from "./BaseMasterDetails.vue?vue&type=template&id=7cf1fa70"
import script from "./BaseMasterDetails.vue?vue&type=script&lang=js"
export * from "./BaseMasterDetails.vue?vue&type=script&lang=js"
import style0 from "./BaseMasterDetails.vue?vue&type=style&index=0&id=7cf1fa70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports